<template lang="pug">
    include ../../Purchase/Form/articles.pug
</template>

<i18n>
{
    "en": {
        "{total} selected": "{total} selected",
        "Do you really want to delete {total} articles?": "Do you really want to delete {total} articles?"
    },
    "de": {
        "Add article to wish list": "Artikel in den Wunschliste legen",
        "no selectable properties": "keine auswählbare Attribute",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Select bulk action...": "Massenaktion auswählen...",
        "{total} selected": "{total} ausgewählt",
        "Go": "Ausführen",
        "Delete...": "Löschen...",
        "Delete": "Löschen",
        "Dismiss": "Abbrechen",
        "Do you really want to delete the selected article?": "Soll der ausgewählte Artikel wirklich gelöscht werden?",
        "Do you really want to delete {total} articles?": "Sollen {total} Artikel wirklich gelöscht werden?",
        "Bulk action processed successfully!": "Massenaktion erfolgreich ausgeführt!",
        "An error occurred!": "Es ist ein Fehler aufgetreten!",
        "Bulk action could not be processed.": "Massenaktion konnte nicht ausgeführt werden."
    }
}
</i18n>

<script>

import _ from 'lodash'
import pinia from '@/pinia';
import { useSetupStore, useShopWishListStore } from '@/stores';
import { adminClient as apolloClient } from '@/store/apollo';

// import Articles from '@/extensions/shop/views/Purchase/Form/Articles'
import articles from '@/extensions/shop/views/Purchase/Form/Mixins/articles'
import CheckAll from '@/components/CheckAll';

export default {
    name: 'WishListArticles',
    // extends: Articles,
    mixins: [articles],
    components: {
        CheckAll,
    },
    data() {
        return {
            scope: 'ex',
            key: 'shop_wish_list_article',
            sortables: [],
            bulk: {
                action: undefined,
                options: [
                    { value: 'delete', label: this.$t('Delete...') },
                ],
                modal: {
                    visibility: false,
                    title: undefined,
                },
            },
        }
    },
    computed: {
        loading() {
            return this.ui.articlesPaginated.loading;
        },
        currency() {
            return _.get(this.form, 'customer.customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        wishListStore() {
            return useShopWishListStore(pinia);
        },
        form() {
            return this.wishListStore.form;
        },
        options() {
            return this.wishListStore.options;
        },
        ui() {
            return this.wishListStore.ui;
        },
        articlesPaginated() {
            return this.wishListStore.articlesPaginated;
        },
        sort() {
            var variables = this.articlesPaginated.variables;
            var defaultSort = this.articlesPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        hasBulkActions() {
            return true;
        },
        bulkSelection() {
            let checked = 'none';
            const total = _.get(this.articlesPaginated, 'pageInfo.total') || 0;
            const selection = _.get(this.articlesPaginated, 'pageInfo.selection');

            if (!selection) return checked;

            if (selection.type === 'exclusive' && selection.identifiers.length < total) checked = 'all';
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                checked = 'visible';
            }
            return checked;
        },
        selectionIndeterminate() {
            let indeterminate = false;
            const selection = _.get(this.articlesPaginated, 'pageInfo.selection');

            if (!selection) return indeterminate;

            if (selection.type === 'exclusive' && selection.identifiers.length) indeterminate = true;
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                const items = _.get(this.articlesPaginated, 'items') || [];
                const currentPageSelection = items.filter(el => selection.identifiers.includes(parseInt(el.id)));
                indeterminate = currentPageSelection.length < items.length;
            }
            return indeterminate;
        },
        bulkModalTitle() {
            const total = _.get(this.articlesPaginated, 'pageInfo.selection.total') || 0;
            if (total === 1) {
                return this.$t('Do you really want to delete the selected article?');
            }
            return this.$t('Do you really want to delete {total} articles?', { total });
        },
    },
    methods: {
        getCurrency(item) {
            return this.currency
        },
        fetchArticlesPaginated(payload) {
            return this.wishListStore.fetchArticlesPaginated(payload);
        },
        updateLoading(value) {
            this.wishListStore.updateArticlesPaginationLoading(value);
        },
        defineItemsPerPage(value) {
            this.wishListStore.defineArticlesPerPage(value);
        },
        defineCurrentPage(value) {
            this.wishListStore.defineArticlesCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.wishListStore.defineArticlesActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.wishListStore.defineArticlesFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.wishListStore.defineArticlesFilterVisibility(value);
        },
        defineSort(payload) {
            this.wishListStore.defineArticlesSorting(payload);
        },
        saveFilterVisibility(payload) {
            return useSetupStore(pinia).saveFilterVisibility(payload);
        },
        isChecked(id) {
            let checked = false;
            const selection = _.get(this.articlesPaginated, 'pageInfo.selection');

            if (!selection) return checked;

            switch (selection.type) {
                case 'inclusive':
                    checked = !!~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;
                case 'exclusive':
                    checked = !~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;
            }
            return checked;
        },
        checkAll(payload) {
            return this.wishListStore.articlesPaginationBulkSelectionCheckAll(payload);
        },
        checkVisible(payload) {
            return this.wishListStore.articlesPaginationBulkSelectionCheckVisible(payload);
        },
        checkItem(item) {
            return this.wishListStore.articlesPaginationBulkSelectionCheckItem(item);
        },
        resetBulkSelection() {
            return this.wishListStore.articlesPaginationBulkSelectionReset();
        },
        handleBulkAction() {
            if (this.bulk.action === 'delete') {
                this.bulk.modal.visibility = true;
            }
        },
        closeBulkModal() {
            this.bulk.modal.visibility = false;
        },
        resetBulkModal() {
            this.bulk.modal = {
                visibility: false,
                title: undefined,
            };
        },
        async executeBulkDelete() {
            this.bulk.modal.visibility = false;
            this.updateLoading(true);

            try {
                const result = await this.wishListStore.processArticlesPaginationBulkAction('delete', this.form.id);
                if (result && result.actions && result.actions.includes('refetch-list')) {
                    await apolloClient.clearStore();
                    await this.refetch();
                }
                this.resetBulkSelection();
                this.bulk.action = undefined;
                this.$notify.success({
                    title: this.$t('Bulk action processed successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            } catch (error) {
                console.error(error);
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Bulk action could not be processed.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000
                });
            } finally {
                this.updateLoading(false);
            }
        },
    }
}
</script>

<style lang="sass" scoped>

.wish-list
    section.articles
        padding: 0

    .price .sale
        color: $--color-danger

.articles :deep(.info-before)
    width: 1px

.articles :deep(.table-top .right)
    display: flex
    align-items: center
    hr.vertical
        display: inline-block
        margin: 0 0.7rem
        border: none
        border-right: 1px solid $--border-color-base
        height: calc(100% - 10px)
        flex-shrink: 0

.articles :deep(.paginated-items .table-top .right .bulk-actions)
    display: inline-flex
    align-items: center
    .el-select
        margin: 0
    .el-button
        margin-left: 10px

.articles :deep(.modal-footer)
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%
</style>
